// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SortLabel--moderator":"fp_a bhg_hq","SortLabel__newFeature":"fp_b bhg_vh bhg_vv"};